import api from "./axios";

const usersApi = {
  getAll: () => api.get("/admin/users"),

  getById: (id) => api.get(`/admin/users/${id}`),

  getHealthData: (id) => api.get(`/admin/users/${id}/health-data`),

  addHealthData: (id, payload) =>
    api.post(`/admin/users/${id}/health-data`, payload),

  getMood: (id) => api.get(`/admin/users/${id}/mood`),

  getSleep: (id) => api.get(`/admin/users/${id}/sleep`),

  getTrends: (id, period = 7) =>
    api.get(`/admin/users/${id}/trends`, { params: { period } }),

  getRiskPrediction: (id) => api.get(`/admin/users/${id}/risk-prediction`),

  getQuestionnaireResults: (id) =>
    api.get(`/admin/users/${id}/questionnaire-results`),

  getCsqResults: (id) => api.get(`/admin/users/${id}/csq-results`),
};

export default usersApi;
